import { getApi, postApi } from '@utils/request';

const prefix = '/video/product';
const homeApi = {
  getCategoryList: (params) => postApi('/product/category/list', params), // 前台类目
  getList: (params) => postApi(`/search/product`, params),
  getDetail: (params) => getApi(`${prefix}/index/get`, params),
  getDescList: (params) => getApi(`${prefix}/description/list`, params),
  add: (params) => postApi(`${prefix}/index/list`, params),
  getHistory: (params) => getApi(`${prefix}/record/list`, params),
  clearHistory: (params) => getApi(`${prefix}/record/clean`, params),
  getBannerList: (params) => getApi('/operation/banner/list', params),
  getCurrentLocation: (params) => getApi('/reverse_geocoding/v3', params), // 百度地图apk获取用户定位
  getUserLocation: (params) => postApi('/reverse/geo/location', params), // 获取用户定位
  getAllShopCityes: () => getApi(`/community/enable/city`), // 获取所有的城市
  getOpenCityes: () => getApi(`/community/enable/city/v2`), // 获取已开通的城市
  getWechatSignature: (params) => getApi('/product/wechat/share', params),
  getSearchResult: (params) => getApi(`/member/product/index/list`, params),
  checkShowCoupon: () => postApi('/index/coupon/show'), // 判断是否弹窗新人券
  // 查询新人优惠券
  getNewUserCoupon: () => postApi('/coupon/query/newuser'),
  // 领取新人券
  receiveNewUserCoupon: (params) => postApi(`/coupon/receive/newuser`, params),
  searchTags: (params) => postApi('/search/product/agg', params), //过滤的标签
  geTrecommend: (params) => postApi(`${prefix}/detail/recommend`, params), //商详推荐
  getRecommandList: (params) => postApi('/product/recommend/orderList', params), // 获取首页推荐商品
  getHotspotList: (params) => postApi('/community/mall/component/home/get', params), // 首页热区
  getCaseRecommandList: (params) => postApi('/video/product/home/page/case', params), // 案例集推荐列表
  getBenifitPopList: (params) => getApi('/benefit/api/pop/list', params), // 弹框列表
  stopBenefitModal: (id) => getApi(`/benefit/api/pop/stop/${id}`)
};
export default homeApi;
